export const mutationTypes = {
  getLicensesStart: '[license] get available licenses start',
  getLicensesSuccess: '[license] get available licenses success',
  getLicensesFailure: '[license] get available licenses failure',

  assignLicensesStart: '[license] assign licenses start',
  assignLicensesSuccess: '[license] assign licenses success',
  assignLicensesFailure: '[license] assign licenses failure',

  massAssignLicensesStart: '[license] mass assign licenses start',
  massAssignLicensesSuccess: '[license] mass assign licenses success',
  massAssignLicensesFailure: '[license] mass assign licenses failure',
};

const mutations = {
  [mutationTypes.getLicensesStart](state) {
    state.licenses = null;
    state.isLoading = true;
  },
  [mutationTypes.getLicensesSuccess](state, payload) {
    state.isLoading = false;
    state.licenses = payload;
  },
  [mutationTypes.getLicensesFailure](state) {
    state.isLoading = false;
  },

  [mutationTypes.assignLicensesStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.assignLicensesSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.assignLicensesFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.massAssignLicensesStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.massAssignLicensesSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.massAssignLicensesFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },
};

export default mutations;
